import React from "react";
import "./../styles/footer.css";
import header_image from "../assets/images/header/caricatura2.png";
import axisbyte_img from "../assets/images/header/axisbyte_logo.png";

// Imagens
import instagramLogo from "../assets/images/icon-instagram-footer.png";
import facebookLogo from "../assets/images/icon-facebook-footer.png";

const Footer = () => {
  const socialMedias = [
    {
      id: "instagram",
      url: "https://www.instagram.com/psicologomarcelomartins/",
      imgSrc: instagramLogo,
      altText: "Instagram",
    },
    {
      id: "facebook",
      url: "https://web.facebook.com/psicologomarcelomartins/",
      imgSrc: facebookLogo,
      altText: "Facebook",
    },
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Redes Sociais */}
        <ul className="social-medias">
          {socialMedias.map((social) => (
            <li key={social.id}>
              <a
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className={social.id}
              >
                <img src={social.imgSrc} alt={social.altText} />
              </a>
            </li>
          ))}
        </ul>

        {/* Direitos Autorais */}
        <div className="right">
          <p>
            Todos os direitos reservados – Marcelo Martins Psicologia Psicanalítica – 2025
          </p>
          <div className="right-links">
            Política de Privacidade | Termos de Uso |{" "}
            <a href="#blog">Blog</a> | <a href="#about">Sobre</a> {" "}
          </div>

          {/* Logos */}
          <div className="dev-logos">
            <img src={header_image} alt="Marcelo Logo" className="logo-arede" />
            <a
              href="https://www.instagram.com/axisbyte.co"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={axisbyte_img} alt="Axisbyte Logo" className="logo-axisbyte" />
            </a>
          </div>

          {/* Crédito */}
          <p className="credit">
            Site desenvolvido por{" "}
            <a
              href="https://www.instagram.com/axisbyte.co"
              target="_blank"
              rel="noopener noreferrer"
            >
              Axisbyte
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
